import dayjs from 'dayjs';

const getResidentACPTagColorAndText = (
  resident: any
): { color: string; displayText: string } => {
  let color: string;
  let displayText: string;
  const text = resident.residentACP;
  const completedDate = resident.user_profile.acp_completed_at;
  const formattedDate = completedDate
    ? dayjs(completedDate).format('DD/MM/YY')
    : '';

  if (text === null || text === undefined) {
    color = '';
    displayText = '';
  } else {
    switch (text.toLowerCase()) {
      case 'completed':
        color = 'green';
        displayText = formattedDate;
        break;
      case 'inprogress':
        color = 'orange';
        displayText = formattedDate || 'In progress';
        break;
      case 'not started':
        color = 'red';
        displayText = 'Not started';
        break;
      default:
        color = '';
        displayText = text.charAt(0).toUpperCase() + text.slice(1);
        break;
    }
  }

  return { color, displayText };
};

const getMentalCapacityColor = (text: string) => {
  let color: string;
  if (text === null || text === undefined) {
    color = '';
  } else {
    switch (text.toLowerCase()) {
      case 'yes':
        color = 'green';
        break;
      case 'no':
        color = 'red';
        break;
      case 'unknown':
        color = 'orange';
        break;
      default:
        color = '';
        break;
    }
  }
  return color;
};

export { getResidentACPTagColorAndText, getMentalCapacityColor };
